import styled from "styled-components";

const Container = styled.div`
  background: #ffff;
  border-radius: 10px 10px 10px 10px;
  margin-bottom: 10px;

  .progress {
    height: 0.5rem !important;
    width: 160px !important;
  }
  .progress-bar {
    background-color: #005586 !important;
  }
`;
const GridContainer = styled.div`
  font-weight: bold;
  color: #005586;
  padding: 15px 30px 15px 30px;
  font-size: 17px;
  cursor: pointer;

  h6 {
    font-weight: bold;
    padding-bottom: 25px;
    font-size: 17px;
    cursor: pointer;

    span {
      font-weight: normal;
      color: grey;
      font-size: 14px;
    }
  }
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background: #dcedf7;
  padding: 5px;
  border-radius: 10px 10px 0 0;
  h6 {
    font-weight: bold;
    padding: 10px 0px 0px 15px;
    font-size: 17px;
    cursor: pointer;
  }
  h4 {
    background: #005586;
    padding: 0px;
    width: 30px;
    border-radius: 50%;
    height: 30px;
    margin: 4px 13px 4px 0px;
    cursor: pointer;
    i {
      border: solid #ffff;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 5px;
      margin: 13px 0px 4px 10px;
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
    }
  }
  h5 {
    background: #005586;
    padding: 0px;
    width: 30px;
    border-radius: 50%;
    height: 30px;
    margin: 4px 13px 4px 0px;
    cursor: pointer;
    i {
      border: solid #ffff;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 5px;
      margin: 0px 0px 2px 10px;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
  }
`;

const AccordionBody = styled.div`
  padding: 15px 30px 15px 30px;
  input {
    border: none;
    border-bottom: 1px solid #afacac;
  }
`;

const ContentWrapper = styled.div`
  padding: 20px;
  .section-header {
    display: flex;
    img {
      height: 40px;
      width: 60px;
      margin: 0px 20px 0px 0px;
    }
    p {
      font-weight: bold;
      font-size: 18px;
    }
  }
  .button-section {
    display: flex;
    justify-content: space-between;
    .save-button {
      background: #005586;
      padding: 5px;
      width: 68px;
      border-radius: 5px;
      color: #fff;
      border: none;
    }
    .skip-button {
      border: none;
      background: #fff;
      text-decoration: underline;
      margin: 5px;
      color: #074269;
    }
    .round-wrapper {
      position: relative;
      height: 40px;
      width: 40px;
      border-radius: 50%;
      margin-left: 10px;
      background: #005586;
      cursor: pointer;
      p {
        position: absolute;
        width: 10px;
        height: 10px;
        top: 7px;
        right: 14px;
        border: solid #fff;
        border-width: 1px 0 0 1px;
      }
    }
    .left {
      p {
        transform: rotate(315deg);
      }
    }
    .right {
      p {
        transform: rotate(135deg);
      }
    }
    .disabled {
      background: #d9d9d9;
      cursor: default;
      p {
        border: solid #000000;
        border-width: 1px 0 0 1px;
      }
    }
  }
`;

const ViewContentWrapper = styled.div`
  .view-edit-button-section {
    display: block;
    text-align: center;
    .save-button {
      background: #005586;
      padding: 5px;
      width: 100px;
      border-radius: 15px;
      color: #fff;
      border: none;
      margin: 5px;
      font-size: 14px;
      svg {
        margin: -3px 5px 1px 0px;
      }
    }
    .cancel-button {
      padding: 5px;
      width: 100px;
      background: #fff;
      border-radius: 15px;
      border: 1px solid;
      margin: 5px;
      font-size: 14px;
    }
    .disabled {
      background: #d9d9d9;
      cursor: default;
      p {
        border: solid #000000;
        border-width: 1px 0 0 1px;
      }
    }
  }
`;

const BreadcrumbWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
  P {
    font-size: 16px;
    color: #6c757d;
    margin: 0;
  }
  h6 {
    font-size: 16px;
    color: #00b3ff;
    margin-top: 3px;
  }
  span {
    font-size: 18px;
    margin: 0 10px 0 10px;
  }
  p:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const InputFieldsWrapper = styled.div`
  h6 {
    color: #ababab;
    font-size: 11px;
    margin-bottom: 3px;
  }
  h4 {
    text-align: center;
    font-weight: bold;
    font-size: 26px;
  }
  h5 {
    text-align: center;
    font-size: 14px;
    margin: 17px 0 0 0px;
    max-width: 370px;
  }
  p {
    color: #ef5657;
    font-size: 11px;
    margin-top: 2px;
  }
  img {
    top: 4px !important;
    left: 6px !important;
    width: 20px;
    height: 20px;
  }
  input {
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    padding: 0;
  }
  .fixed-height {
    position: relative;
    min-height: 72px;
    .height-adjust {
      position: absolute;
      top: 15px;
      width: 90%;
    }
  }
  .date-style {
    border: 1px solid #87cdf1 !important;
    border-radius: 2px !important;
    padding: 0px 20px 0 15px !important;
    height: 35px;
  }
  .green-button {
    background: linear-gradient(90deg, #55c416 1.12%, #367910 100%);
    border: none;
    border-radius: 5px;
    height: 35px;
    width: fit-content;
    padding: 5px;
    color: #fff;
    font-size: 14px;
  }
  .bordered-input {
    input {
      border: 1px solid #87cdf1 !important;
      border-radius: 5px !important;
      padding-left: 10px !important;
    }
  }
  .date-border-adjust {
    input {
      border: none;
      padding: 5px;
    }
  }
  .error-styling-input {
    input {
      border: none !important;
      border-bottom: 1px solid #ef5657 !important;
    }
  }
  .table thead th,
  .table td,
  .table th {
    font-size: 14px;
  }
  .userlist-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 0 15px 0;
    h1 {
      font-size: 16px;
      font-weight: bold;
    }
    img {
      cursor: pointer;
    }
  }
  .app-input-text {
    margin-bottom: 15px !important;
  }
  .app-input-text input.error {
    border: none !important;
    border-bottom: 1px solid #ef5657 !important;
  }
  .radio-checkmark {
    top: 2.5px !important;
    border: 1px solid #005586 !important;
  }
  .radio-checkmark:after {
    background: #005586 !important;
  }
  .radioField {
    span {
      font-size: 14px;
    }
  }
  .checkbox-field {
    margin: 0 0 0 14px !important;
  }
  .checkbox-container {
    font-size: 14px !important;
  }
  .checkMark {
    border: solid 2px #d5d5d5 !important;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkMark {
    background: linear-gradient(to bottom, #f7f9fa 0%, #f7f9fa 100%) !important;
  }

  /* Style the checkMark/indicator */
  .checkMark:after {
    border: solid black !important;
    border-width: 0 3px 3px 0 !important;
  }

  .completion-page {
    height: 435px;
    padding: 90px 0 100px 0;
    text-align: center;
    img {
      width: 55px;
      height: 55px;
      margin: 20px;
    }
    .save-button {
      background: #005586;
      padding: 5px;
      width: 68px;
      border-radius: 5px;
      color: #fff;
      border: none;
    }
  }
  .download-btn {
    border: none;
    background: linear-gradient(rgb(97, 176, 31) 0%, rgb(39, 145, 27) 100%);
    border-radius: 5px;
    padding: 0px;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 38px;
    height: 28px;
  }
`;

const ProgressBarWithoutLabel = styled.div`
  .MuiCircularProgress-colorPrimary {
    width: 100px !important;
    height: 100px !important;
    color: #e5e5e5 !important;
  }
`;

const ProgressBarWithLabel = styled.div`
  position: relative;
  left: -100px;
  .MuiCircularProgress-colorPrimary {
    width: 100px !important;
    height: 100px !important;
    color: #69bbe0 !important;
  }
`;

const CompWrapper = styled.div`
  margin-top: 20px;
  background: #fff;
  border-radius: 10px;
  .main-wrapper {
    display: grid;
    grid-template-columns: 1fr 2fr;
    min-height: 430px;
  }
  .image-wrapper {
    background: linear-gradient(255deg, #ffff 35%, #e2e2e2 29%);
    width: 374px;
    border-radius: 10px;
    position: relative;
    img {
      position: absolute;
      bottom: 0;
      height: 300px;
      width: 300px;
      margin-top: 344px;
    }
  }
  @media (max-width: 1024px) {
    .main-wrapper {
      grid-template-columns: 1fr;
    }
    .image-wrapper {
      display: none;
    }
  }
`;

const ModalStyles = styled.div`
  .confirmation-content {
    text-align: center;
    padding-top: 10px;
  }
  button {
    margin: 15px 10px 10px 10px;
    border: none;
    border-radius: 5px;
    width: 60px;
    padding: 3px;
  }
  .no-button {
    background: #6b7173;
  }
  .yes-button {
    background: linear-gradient(180deg, #55c416 0%, #367910 100%);
  }
`;

const CheckBoxWrapper = styled.div`
  .checkbox-field {
    margin: 10px 0;
  }
`;

const FlatFeeModalWrapper = styled.div`
  .modal-body {
    padding: 0px !important;
  }
  .modal-content {
    border-radius: 0px !important;
  }
  .modal-header-style {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #e6e6e6;
    border-radius: 0px;
    h6 {
      margin: 12px 12px 12px 25px;
      font-weight: bold;
    }
    img {
      margin: 12px 25px 12px 12px;
      height: 20px;
      width: 20px;
      cursor: pointer;
    }
  }
  .modal-content-style {
    display: flex;
    padding: 15px 25px 15px 25px;
    justify-content: space-between;
    input {
      min-width: 404px;
      font-size: 16px;
    }
    input::-webkit-input-placeholder {
      color: #9c9c9c !important;
      font-size: 14px !important;
    }
    .invite-email-style {
      padding: 5px 5px 5px 15px;
      border: 1px solid #dadadf;
      border-radius: 4px;
      width: 75%;
      font-size: 14px;
    }
    .invite-button-disabled {
      margin-left: 10px;
      width: 100px;
      height: 40px;
      background: #f2f2f2;
      border: 1px solid #f2f2f2;
      border-radius: 4px;
      font-size: 14px;
    }
    .invite-button {
      margin-left: 10px;
      width: 100px;
      height: 40px;
      background: linear-gradient(180deg, #55c416 0%, #367910 100%);
      border: 1px solid #f2f2f2;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
    }
    .app-input-text {
      margin-bottom: 15px !important;
    }
  }
`;

export {
  Container,
  AccordionHeader,
  AccordionBody,
  ProgressBarWithoutLabel,
  ProgressBarWithLabel,
  CompWrapper,
  ModalStyles,
  ContentWrapper,
  InputFieldsWrapper,
  CheckBoxWrapper,
  ViewContentWrapper,
  BreadcrumbWrapper,
  FlatFeeModalWrapper,
  GridContainer,
};
